import { CampaignProductAd } from './campaign-product-ad';

export class ProductAds {
  itemKey: string;
  name: string;
  sku: string;
  asin: string;
  eligibilityStatus: string;
  active: boolean;
  isAutomatic?: boolean;
  children?: CampaignProductAd[];
  adGroup: AdGroup;
  budget: string;
  target: string;
  adLog: AdLog;
  autoAdjustment: string;
  createdAt: Date = new Date();
  updatedAt: Date = new Date();
  startDate: string;
  endDate: string;

  daysUntilStockOut: number;
  minDaysStockout: number | null;
  maxDaysStockout: number | null;
  onHand: number;
  onHandFbm: number;
  awdInventoryQty: number;
  inboundShipped: number;
  inboundReceiving: number;
  inboundShippedAwd: number;
  inboundReceivingAwd: number;
  inbound?: number;
  inboundFcTransfer?: number;
  inventoryAvailable: number;
  saleVelocity: number;
  inventorySourcePreference: string;
  isUsingAwdInventoryQty?: boolean;
  inventoryStatus?: string;
  adStockOutStatus?: string;
  suggestAction?: string;
  managedBySystem?: boolean;
  allCampaignsPaused?: boolean;

  constructor(init?: Partial<ProductAds>) {
    if (init) {
      // if no values are passed in, fresh instantiation
      Object.assign(this, init);
    }
  }
}

class AdGroup {
  adGroupName: string;
  totalTargets: number;
  products: number;
  spend: number;
  orders: number;
  sales: number;
  roas: number;
  status: string
}

class AdLog {
  createdAt: Date;
  daysUntilStockout: number;
  minDaysStockoutThreshold: number;
  maxDaysStockoutThreshold: number; 
  previourBudgetValue: number;
  presentBudgetValue: number;
  itemStatus: string;
}

export enum ProductAdState {
  ENABLED = 'ENABLED',
  PAUSED = 'PAUSED',
  PROPOSED = 'PROPOSED',
}

export enum ManagedScope {
  MANAGED = 'managed',
  EXTERNAL = 'external',
  ALL = 'all',
  ELIGIBLE = 'eligible',
}